module.exports = "<h3 class=\"padding-top text-center\">{{ 'Brands' | translate | async }}</h3>\n\n<article class=\"row padding-top padding-top-2x\">\n  <ul class=\"brand-list\" *ngFor=\"let first of brandKeys();\">\n    <li class=\"group-title\">{{ first }}</li>\n    <li *ngFor=\"let brand of brandsGrouped[first]\">\n      <a class=\"brand\"\n         [routerLink]=\"['/brands/' + brand.name ]\">\n        <p class=\"brand-text\">{{ brand.name }}</p>\n      </a>\n    </li>\n  </ul>\n</article>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Templates/brand.list.html
// module id = ./src/app/Templates/brand.list.html
// module chunks = main